<template>
  <li
    @click="selectDate(day)"
    class="cc-calendar-day"
    :class="{
      'cc-calendar-day--not-current': !day.isCurrentMonth,
      'cc-calendar-day--today': isToday,
      'cc-calendar-day--range': inRange,
      'cc-calendar-day--arrival': isArrival,
      'cc-calendar-day--departure': isDeparture,
      'cc-calendar-day--arrival-day': isArrivalDay,
      'cc-calendar-day--departure-day': isDepartureDay,
      'cc-calendar-day--disabled': isDisabled,
    }"
  >
    <span>{{ label }}</span>
  </li>
</template>

<script>

import dayjs from "dayjs";

export default {
  name: "CalendarMonthDayItem",

  props: {
    day: {
      type: Object,
      required: true
    },

    isCurrentMonth: {
      type: Boolean,
      default: false
    },

    isToday: {
      type: Boolean,
      default: false
    },

    isArrival: {
      type: Boolean,
      default: false
    },

    isDeparture: {
      type: Boolean,
      default: false
    },

    isArrivalDay: {
      type: Boolean,
      default: true
    },

    isDepartureDay: {
      type: Boolean,
      default: true
    },

    inRange: {
      type: Boolean,
      default: false
    },

    isDisabled: {
      type: Boolean,
      default: false
    },

  },

  computed: {
    label() {
      return dayjs(this.day.date).format("D");
    }
  },
  methods: {

    selectDate(day){
      
      // check if we may select this day
      if(!this.isArrivalDay && !this.isDepartureDay){
        alert(this.$t('This is not a valid arrival and departure day'));
        return;
      }

      if(this.isDisabled){
        alert(this.$t('Unfortunately there is no availability on this day'));
        return;
      }
    
      // fire event
      this.$emit("daySelected", day);

    }

  }

};
</script>
